import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { addPayment } from "././addPayment";

import {
  SalesOrderService,
  ComboService
} from "../../../services/index";

@Component({
  selector: "addEdit-SalesReturn-Bundle",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addCourierInward.html",
})
export class addCourierInward {
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  // boxTypeList = ["PAYMENT","LR INVOICE","INVITATION"];
  boxTypeList = ["CHEQUE","DD","LR INVOICE","BILLS","COTTON BOX","BUTTON SAMPLE","SAMPLE BOX","FABRICS","SAMPLE","THREAD","INVITATION","OTHERS"];

  RecTypeList = ["HAND","COURIER","LORRY","VAN"]
  courierdata: any = {
    ref_no: 0,
    cour_date: "",
    entry_date: new Date(),
    cour_type: "",
    cour_name: "",
    cour_no: "",
    rec_type: "",
    lr_no: "",
    lr_date: "",
    qty:"",
    dc_no: "",
    particulars: "",
    remarks: "",
    desc:""
  };

  @Input() _params: any;
  @Input() active = false;
  @Input("tabID") tabID: string;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    if (this.mode == "View") {
      // this.loaddesignList(this.courierdata.creditid);
      this.courierdata = designdata;
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private modalService: BsModalService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,

  ) { }
  ngOnInit() {

    this.getCourierAuto()
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#cour_date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);

    }
  }



  // loaddesignList(id) {
  //   let params = {
  //     creditid: id,
  //     order_type: "Order Form",
  //     page: 1,
  //     start: 0,
  //     limit: 100,
  //   };
  //   this.salesservice.getSiRtnEntryGridShirtSizeDet(params).then((res: any) => {
  //     this.courierdata = res;

  //   });
  // }


  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getCourierAuto() {

    if (this.mode == "Add") {
      this.salesservice.getCourierAuto({}).then((res: any) => {
        this.courierdata.ref_no = res;
        // this.getWoAuto();
      });

    }

  }


  oncheckemptyrow() {
    // let design = this.courierdata;
    // let empty_check = false;
    // for (var key in design) {
    //   if (!design[key]) {
    //     swal("PLEASE ENTER ALL THE DETAILS!");
    //     empty_check = true;
    //     console.log(design[key])
    //   }

    // }
    // if (!empty_check) {
    //   this.onSaveOrder();
    // }

    this.onSaveOrder();

  }


  bsModalRef: BsModalRef;
  onSaveOrder() {

    this.courierdata.entry_date = this.datePipe.transform(
      this.courierdata.entry_date,
      "yyyy-MM-dd"
    );

    this.courierdata.cour_date = this.datePipe.transform(
      this.courierdata.cour_date,
      "yyyy-MM-dd"
    );
    this.courierdata.lr_date = this.datePipe.transform(
      this.courierdata.lr_date,
      "yyyy-MM-dd"
    );
    
    let params: any = Object.assign({}, this.courierdata);
    params["mode"] = this.mode
 
   

    let that = this;
    that.isLoading = true;
    if (that.mode == "Add") {
      swal({
        title: "Are you sure to save this Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesservice
          .addCourierDet(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
              // console.log(that.saveEvent)
            }
            if (res.success) {
              //    that.printdata(res.printData);
             
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if ((that.mode == "Add" && that.courierdata.particulars == "CHEQUE") || (that.mode == "Add" && that.courierdata.particulars == "DD")) {
                that.bsModalRef = that.modalService.show(addPayment, {
                  keyboard: false,
                  ignoreBackdropClick: true,
                  class: "compWidth-90",
                });
                   res["mode"] = that.mode
                   res["cour_data"] = that.courierdata
                that.bsModalRef.content.paymentdata = Object.assign({}, res);
                that.bsModalRef.content.paymentUpdateEvent.subscribe(($e) => {
                  // that.getCourierList
                  const tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                
                });
              }
              else if(that.mode == "Add" && that.courierdata.particulars == "LR INVOICE"){
              
                let tabObj = {
                  action: "NewTab",
                  params: {
                    tabName: "ADD PURCHASE INVOICE",
                    title: "ADD PURCHASE INVOICE",
                    tabParent: "CLOTH",
                    mode: that.mode,
                    data: [],
                    name: "AddEditInvoice",
                  },
                  // params: {
                  //   tabParent: "CLOTH",
                  //   tabName: "ADD PURCHASE INVOICE",
                  //   id: "AddEditInvoice",
                  //   name: "EDIT PURCHASE INVOICE",
                  //   mode: mode,
                  //   data: row,
                  // },
                };
                that.tabUpdateEvent.emit(tabObj);
              }
              else{
                     const tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/courier/addCourierInward.ts